// extracted by mini-css-extract-plugin
export default {"switch":"SwitchButton_switch__CzL7Q","slider":"SwitchButton_slider__Nvqdb","rounded":"SwitchButton_rounded__8wrmE"};